import {Component, EventEmitter, Input, Output} from '@angular/core';
import {OrganizationExperienceService} from "../../services/organization-experience.service";
import {MilestonesService} from "../../services/milestones.service";
import {Milestone} from "../../interfaces/milestone";
import {Overlayable} from "../../interfaces/overlayable";

@Component({
  selector: 'brt-milestones-progress-overlay',
  templateUrl: './milestones-progress-overlay.component.html',
  styleUrls: ['./milestones-progress-overlay.component.scss']
})
export class MilestonesProgressOverlayComponent implements Overlayable {
  @Output('onClosed') onClosed = new EventEmitter<boolean>();
  @Input('experience') set setExperience(value: number) {
    this.currentExperience = value;
  }

  currentExperience = -1;

  milestones: Milestone[] = this.milestonesService.getMilestones();

  constructor(private milestonesService: MilestonesService) {
  }
}
